const postGiftCard = async (data) => {
  const response = await fetch('/gift-card/checkout', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
  return await response.json()
}

export {
  postGiftCard
}
